var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcontable = function SvgIcontable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    d: "M11.375.75h-9.75C.992.75.5 1.266.5 1.875v8.25a1.11 1.11 0 0 0 1.125 1.125h9.75c.61 0 1.125-.492 1.125-1.125v-8.25A1.14 1.14 0 0 0 11.375.75m-5.437 9.375H1.766q-.141 0-.141-.14V6.937h4.313zm0-4.312H1.625V2.625h4.313zm5.296 4.312H7.063V6.938h4.312v3.046c0 .094-.07.141-.14.141m.141-4.312H7.063V2.625h4.312z"
  })));
};
export default SvgIcontable;